<ng-container *transloco="let t">
    <div class="chapter mt-3" [id]="'chapter-1'" #chapter>
        <ul class="heading-ul">
            <li class="heading-li">
                <a (click)="scrollToChapter(1)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.1.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(2)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.2.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(3)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.3.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(4)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.4.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(5)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.5.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(6)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.6.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(7)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.7.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(8)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.8.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(9)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.9.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(10)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.10.title') }}</p>
                </a>
            </li>
            <li class="heading-li">
                <a (click)="scrollToChapter(11)">
                    <p class="fw-medium fs-28 pb-2">{{ t('policy.general.conditions.chapter.11.title') }}</p>
                </a>
            </li>
        </ul>

    </div>

    <div class="chapter mt-3" [id]="'chapter-1'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.1.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.1.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.2')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.3')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.4')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.5')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.6')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.7')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.8')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.9')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.10.1')"></p>
        <p class="pt-2" [innerHTML]="t('policy.general.conditions.chapter.1.10.2')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.1.11')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-2'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.2.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.2.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.2.2')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.2.3')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.2.4')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-3'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.3.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.3.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.2')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.3')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.4')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.5')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.6')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.7')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.8')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.9')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.10')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.11')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.12')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.3.13')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-4'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.4.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.4.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.4.2')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.4.3')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.4.4')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.4.5')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.4.6')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-5'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.5.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.5.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.5.2')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-6'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.6.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.6.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.6.2')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-7'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.7.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.7.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.7.2')"></p>
        <p class="pt-3 pb-3" [innerHTML]="t('policy.general.conditions.chapter.7.3')">
        </p>
        <ul>
            <li><p>{{t('policy.general.conditions.chapter.7.3.1')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.2')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.3')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.4')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.5')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.6')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.7')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.8')}}</p></li>
            <li><p>{{t('policy.general.conditions.chapter.7.3.9')}}</p></li>
        </ul>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.7.4')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-8'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.8.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.8.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.8.2')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-9'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.9.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.9.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.9.2')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.9.3')"></p>
    </div>

    <div class="chapter mt-3" [id]="'chapter-10'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.10.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.10.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.10.2')"></p>

    </div>

    <div class="chapter mt-3" [id]="'chapter-11'" #chapter>
        <p class="fw-medium fs-28">
            {{ t('policy.general.conditions.chapter.11.title') }}
        </p>
        <p class="pt-4" [innerHTML]="t('policy.general.conditions.chapter.11.1')"></p>
        <p class="pt-3" [innerHTML]="t('policy.general.conditions.chapter.11.2')"></p>
    </div>
</ng-container>
